module.exports = __webpack_public_path__ + "img/entreprise.35d5ce4c.png";